import React from 'react';
import { Badge, Box, Button, Checkbox, FormControl, Grid, IconButton, MenuItem, Radio, RadioGroup, Stack, Typography } from '@mui/material';
import styles from '../../../../../../../custom/style.module.css';
import { CustomButton, CustomCheckbox, CustomInputLabel, CustomRadio, CustomSelect, CustomTextField, InputProps, NUMBERINPUT_PROPS, SelectInputProps, StyledCard } from '../../../../../../../custom/components';
import { AddIcon, DeleteIcon } from 'custom/constants';
import importStyles from './servicecatalog.module.css';
import { AccessTime } from '@mui/icons-material';

const AdditionalService = (props) => {
  const InputStyles = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    minWidth: '150px',
  };
  const { action, serviceFields, serviceFieldsErrors, onChange, addService, editService, onChangeOperation } = props;
  return (
    <form onSubmit={action == 'add' ? addService : editService} onReset={props.onClose} className={styles.w100}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <CustomInputLabel htmlFor='service' required>Service</CustomInputLabel>
          <CustomTextField
            {...InputProps}
            fullWidth
            id='service'
            placeholder='Service'
            type='text'
            onChange={onChange}
            name='key'
            value={serviceFields.key}
            error={serviceFieldsErrors.key}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <CustomInputLabel htmlFor='des' required>Description</CustomInputLabel>
          <CustomTextField
            {...InputProps}
            fullWidth
            autoFocus
            id='des'
            placeholder='Description'
            type='text'
            rows={4}
            multiline
            onChange={onChange}
            name='description'
            value={serviceFields.description}
            error={serviceFieldsErrors.description}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <Stack spacing={2} direction='row' borderBottom={'1px solid lightgrey'}>
            <CustomInputLabel>Operations</CustomInputLabel>
          </Stack>
          {serviceFields && serviceFields.value?.map((value, index) => {
            return (
              <StyledCard key={index} className={importStyles.operationCard}>
                <Grid container spacing={3}>
                  <Grid item xs={6} lg={2} {...InputStyles}>
                    <CustomInputLabel className={importStyles.labelWrap} htmlFor='type' required>Type</CustomInputLabel>
                    <FormControl variant='standard' fullWidth>
                      <CustomSelect
                        {...SelectInputProps}
                        index={index}
                        fullWidth
                        id='type'
                        name='type'
                        value={value.type}
                        onChange={(e) => onChangeOperation(index, e)}
                        error={serviceFieldsErrors?.value && serviceFieldsErrors.value[index]?.type}
                        classes={{
                          root: importStyles.operationsIpRoot,
                          select: importStyles.operationsIpSelect,
                          input: importStyles.operationsIp
                        }}
                      >
                        <MenuItem value='' disabled>Select Type</MenuItem>
                        <MenuItem value='add'>Add</MenuItem>
                        <MenuItem value='subtract'>Subtract</MenuItem>
                      </CustomSelect>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} lg={2} {...InputStyles}>
                    <CustomInputLabel className={importStyles.labelWrap} htmlFor='unit' required>Unit Type</CustomInputLabel>
                    <FormControl variant='standard' fullWidth>
                      <CustomSelect
                        {...SelectInputProps}
                        fullWidth
                        id='unit'
                        name='unit'
                        value={value.unit}
                        onChange={(e) => onChangeOperation(index, e)}
                        error={serviceFieldsErrors?.value && serviceFieldsErrors.value[index]?.unit}
                        classes={{
                          root: importStyles.operationsIpRoot,
                          select: importStyles.operationsIpSelect,
                          input: importStyles.operationsIp
                        }}
                      >
                        <MenuItem disabled>Select Unit</MenuItem>
                        <MenuItem value='cost'>Cost (Fixed)</MenuItem>
                        <MenuItem value='cost_manual'>Cost (Manual)</MenuItem>
                        <MenuItem value='number'>Number (Custom)</MenuItem>
                        <MenuItem value='kg'>Kg (Auto)</MenuItem>
                        <MenuItem value='kg_per_day'>Storage (Auto)</MenuItem>
                        <MenuItem value='percent'>Percent</MenuItem>
                      </CustomSelect>
                    </FormControl>
                  </Grid>
                  {value.unit == 'number' && (
                    <Grid item xs={6} lg={2} {...InputStyles}>
                      <CustomInputLabel className={importStyles.labelWrap} htmlFor='value' required>Unit Name</CustomInputLabel>
                      <CustomTextField
                        fullWidth
                        id='value'
                        placeholder='Unit Name'
                        type='text'
                        onChange={(e) => onChangeOperation(index, e)}
                        name='unit_key'
                        value={value.unit_key}
                        InputProps={{
                          disableUnderline: true,
                          classes: {
                            root: importStyles.operationsIpRoot,
                            input: importStyles.operationsIp
                          },
                        }}
                        sx={NUMBERINPUT_PROPS}
                        error={serviceFieldsErrors?.value && serviceFieldsErrors.value[index]?.unit_key}
                      />
                    </Grid>
                  )}
                  {['number', 'kg', 'kg_per_day']?.includes(value.unit) && (
                    <Grid item xs={6} lg={2} {...InputStyles}>
                      <CustomInputLabel className={importStyles.labelWrap} htmlFor='cost_per_unit' required>Cost Per Unit</CustomInputLabel>
                      <CustomTextField
                        fullWidth
                        id='cost_per_unit'
                        placeholder=''
                        type='number'
                        onChange={(e) => onChangeOperation(index, e)}
                        name='cost_per_unit'
                        value={value.cost_per_unit}
                        InputProps={{
                          disableUnderline: true,
                          classes: {
                            root: importStyles.operationsIpRoot,
                            input: importStyles.operationsIp
                          },
                        }}
                        sx={NUMBERINPUT_PROPS}
                        error={serviceFieldsErrors?.value && serviceFieldsErrors.value[index]?.cost_per_unit}
                      />
                    </Grid>
                  )}
                  {value.unit == 'cost' && (
                    <Grid item xs={6} lg={2} {...InputStyles}>
                      <CustomInputLabel className={importStyles.labelWrap} htmlFor='cost' required>Cost</CustomInputLabel>
                      <CustomTextField
                        fullWidth
                        id='cost'
                        placeholder='Cost'
                        type='number'
                        onChange={(e) => onChangeOperation(index, e)}
                        name='cost'
                        value={value.cost}
                        className={importStyles.operationsTextfield}
                        InputProps={{
                          disableUnderline: true,
                          classes: {
                            root: importStyles.operationsIpRoot,
                            input: importStyles.operationsIp
                          },
                        }}
                        sx={NUMBERINPUT_PROPS}
                        error={serviceFieldsErrors?.value && serviceFieldsErrors.value[index]?.cost}
                      />
                    </Grid>
                  )}
                  {value.unit == 'percent' && (
                    <Grid item xs={6} lg={2} {...InputStyles}>
                      <CustomInputLabel className={importStyles.labelWrap} htmlFor='percent' required>Percent</CustomInputLabel>
                      <CustomTextField
                        fullWidth
                        id='percent'
                        placeholder='Percent'
                        type='number'
                        onChange={(e) => onChangeOperation(index, e)}
                        name='percent'
                        value={value.percent}
                        className={importStyles.operationsTextfield}
                        InputProps={{
                          disableUnderline: true,
                          classes: {
                            root: importStyles.operationsIpRoot,
                            input: importStyles.operationsIp
                          },
                        }}
                        sx={NUMBERINPUT_PROPS}
                        error={serviceFieldsErrors?.value && serviceFieldsErrors.value[index]?.percent}
                      />
                    </Grid>
                  )}
                  {value.unit == 'percent' && (
                    <Grid item xs={6} lgmd={2} {...InputStyles}>
                      <CustomInputLabel className={importStyles.labelWrap} htmlFor='from_service' required>From Service</CustomInputLabel>
                      <CustomSelect
                        fullWidth
                        id='from_service'
                        name='from_service'
                        value={value.from_service}
                        onChange={(e) => onChangeOperation(index, e)}
                        error={serviceFieldsErrors?.value && serviceFieldsErrors.value[index]?.from_service}
                        classes={{
                          root: importStyles.operationsIpRoot,
                          select: importStyles.operationsIpSelect,
                          input: importStyles.operationsIp
                        }}
                      >
                        <MenuItem value='' disabled>Select Service</MenuItem>
                        {props.services?.map((service) => {
                          if (service.key != serviceFields.key)
                            return <MenuItem key={service.id} value={service.key}>{service.key}</MenuItem>;
                        })}
                      </CustomSelect>
                    </Grid>
                  )}
                  {value.unit == 'kg_per_day' && (
                    <Grid item xs={6} lg={2} {...InputStyles}>
                      <CustomInputLabel className={importStyles.labelWrap} htmlFor='unit_divisor' required>Unit Divisor</CustomInputLabel>
                      <CustomTextField
                        fullWidth
                        id='unit_divisor'
                        placeholder=''
                        type='number'
                        onChange={(e) => onChangeOperation(index, e)}
                        name='unit_divisor'
                        value={value.unit_divisor}
                        className={importStyles.operationsTextfield}
                        InputProps={{
                          disableUnderline: true,
                          classes: {
                            root: importStyles.operationsIpRoot,
                            input: importStyles.operationsIp
                          },
                        }}
                        sx={NUMBERINPUT_PROPS}
                        error={serviceFieldsErrors?.value && serviceFieldsErrors.value[index]?.unit_divisor}
                      />
                    </Grid>
                  )}
                  {value.unit == 'kg_per_day' && (
                    <Grid item xs={6} lg={2} {...InputStyles}>
                      <CustomInputLabel className={importStyles.labelWrap} htmlFor='mim_cost_per_day' required>Min</CustomInputLabel>
                      <CustomTextField
                        fullWidth
                        id='mim_cost_per_day'
                        placeholder=''
                        type='number'
                        onChange={(e) => onChangeOperation(index, e)}
                        name='mim_cost_per_day'
                        value={value.mim_cost_per_day}
                        className={importStyles.operationsTextfield}
                        InputProps={{
                          disableUnderline: true,
                          classes: {
                            root: importStyles.operationsIpRoot,
                            input: importStyles.operationsIp
                          },
                        }}
                        sx={NUMBERINPUT_PROPS}
                        error={serviceFieldsErrors?.value && serviceFieldsErrors.value[index]?.mim_cost_per_day}
                      />
                    </Grid>
                  )}
                  {value.unit == 'kg_per_day' && (
                    <Grid item xs={6} lg={2} {...InputStyles}>
                      <CustomInputLabel className={importStyles.labelWrap} htmlFor='free_days' required>Free Days</CustomInputLabel>
                      <CustomTextField
                        fullWidth
                        id='free_days'
                        placeholder=''
                        type='number'
                        onChange={(e) => onChangeOperation(index, e)}
                        name='free_days'
                        value={value.free_days}
                        className={importStyles.operationsTextfield}
                        InputProps={{
                          disableUnderline: true,
                          classes: {
                            root: importStyles.operationsIpRoot,
                            input: importStyles.operationsIp
                          },
                        }}
                        sx={NUMBERINPUT_PROPS}
                        error={serviceFieldsErrors?.value && serviceFieldsErrors.value[index]?.free_days}
                      />
                    </Grid>
                  )}
                  {/* first_weekend_free */}
                  {value.unit == 'kg_per_day' && (
                    <Grid item xs={6} md={12}>
                      <Box className={importStyles.operationsCheckboxWrap}>
                        <Grid container columnSpacing={2}>
                          <Grid item xs={12} md={12}>
                            <CustomCheckbox
                              control={
                                <Checkbox
                                  name='first_weekend_free'
                                  color='primary'
                                  checked={value.first_weekend_free}
                                  onChange={(e) => onChangeOperation(index, e)}
                                  inputProps={{ 'aria-label': 'first_weekend_free' }}
                                  className={importStyles.operationsCheckboxIcon}
                                />
                              }
                              label='First Weekend Free'
                              labelPlacement='end'
                              className={importStyles.operationsCheckbox}
                              classes={{ label: importStyles.operationsLabel }}
                            />
                          </Grid>
                          <Grid item xs={12} md={12}>
                            <CustomCheckbox
                              control={
                                <Checkbox
                                  name='arrival_day_counted'
                                  color='primary'
                                  checked={value.arrival_day_counted}
                                  onChange={(e) => onChangeOperation(index, e)}
                                  inputProps={{ 'aria-label': 'arrival_day_counted' }}
                                  className={importStyles.operationsCheckboxIcon}
                                />
                              }
                              label='Arrival Day Counted'
                              labelPlacement='end'
                              className={importStyles.operationsCheckbox}
                              classes={{ label: importStyles.operationsLabel }}
                            />
                          </Grid>
                          <Grid item xs={12} md={12}>
                            <CustomCheckbox
                              control={
                                <Checkbox
                                  name='office_hour_counted'
                                  color='primary'
                                  checked={value.office_hour_counted}
                                  onChange={(e) => onChangeOperation(index, e)}
                                  inputProps={{ 'aria-label': 'office_hour_counted' }}
                                  className={importStyles.operationsCheckboxIcon}
                                />
                              }
                              label='Adjust Arrival Day Based On Office Hours'
                              labelPlacement='end'
                              className={importStyles.operationsCheckbox}
                              classes={{ label: importStyles.operationsLabel }}
                            />
                          </Grid>
                          <Grid item xs={12} md={12}>
                            <CustomCheckbox
                              control={
                                <Checkbox
                                  name='all_public_holidays_counted'
                                  color='primary'
                                  checked={value.all_public_holidays_counted}
                                  onChange={(e) => onChangeOperation(index, e)}
                                  inputProps={{ 'aria-label': 'all_public_holidays_counted' }}
                                  className={importStyles.operationsCheckboxIcon}
                                />
                              }
                              label='All Public Holidays Counted'
                              labelPlacement='end'
                              className={importStyles.operationsCheckbox}
                              classes={{ label: importStyles.operationsLabel }}
                            />
                          </Grid>
                          <Grid item xs={12} md={12}>
                            <CustomCheckbox
                              control={
                                <Checkbox
                                  name='first_public_holiday_counted'
                                  color='primary'
                                  checked={value.first_public_holiday_counted}
                                  onChange={(e) => onChangeOperation(index, e)}
                                  inputProps={{ 'aria-label': 'first_public_holiday_counted' }}
                                  className={importStyles.operationsCheckboxIcon}
                                />
                              }
                              label='First Public Holiday Counted'
                              labelPlacement='end'
                              className={importStyles.operationsCheckbox}
                              classes={{ label: importStyles.operationsLabel }}
                            />
                          </Grid>
                          {/* <Grid item xs={12} md={12}>
                            <CustomCheckbox
                              control={
                                <Checkbox
                                  name='first_weekend_holiday_free_without_day_after_free_period'
                                  color='primary'
                                  checked={value.first_weekend_holiday_free_without_day_after_free_period}
                                  onChange={(e) => onChangeOperation(index, e)}
                                  inputProps={{ 'aria-label': 'first_weekend_holiday_free_without_day_after_free_period' }}
                                  className={importStyles.operationsCheckboxIcon}
                                />
                              }
                              label='First Weekend Holiday Free Without Day After Free Period'
                              labelPlacement='end'
                              className={importStyles.operationsCheckbox}
                              classes={{ label: importStyles.operationsLabel }}
                            />
                          </Grid> */}
                          <Grid item xs={12} md={12}>
                            <CustomCheckbox
                              control={
                                <Checkbox
                                  name='weekend_holiday_not_free_after_free_period'
                                  color='primary'
                                  defaultChecked
                                  checked={value.weekend_holiday_not_free_after_free_period}
                                  onChange={(e) => onChangeOperation(index, e)}
                                  inputProps={{ 'aria-label': 'weekend_holiday_not_free_after_free_period' }}
                                  className={importStyles.operationsCheckboxIcon}
                                />
                              }
                              label='Weekend/Holiday Not Free After Free Period'
                              labelPlacement='end'
                              className={importStyles.operationsCheckbox}
                              classes={{ label: importStyles.operationsLabel }}
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>
                  )}
                  {value.unit == 'kg_per_day' && (
                    <Grid item xs={12} lg={12} {...InputStyles}>
                      <CustomInputLabel className={importStyles.labelWrap} htmlFor='rate_applied_on' required>Minimun Storage To Applied On</CustomInputLabel>
                      <RadioGroup
                        name='rate_applied_on'
                        row
                        defaultValue='total_cost'
                        value={value.rate_applied_on ? value.rate_applied_on : 'total_cost'}
                        onChange={(e) => onChangeOperation(index, e)}
                      >
                        <CustomRadio control={<Radio size='small' />} value='total_cost' label='Total Cost' />
                        <CustomRadio control={<Radio size='small' />} value='per_day' label='Per Day' />
                      </RadioGroup>
                    </Grid>
                  )}
                  {value.unit == 'kg_per_day' && (
                    <Grid item xs={12} lg={12} {...InputStyles}>
                      <CustomInputLabel className={importStyles.labelWrap} htmlFor='Round'>Rounding</CustomInputLabel>
                      <RadioGroup
                        name='rounding'
                        row
                        defaultValue={''}
                        value={value.rounding ? value.rounding : ''}
                        onChange={(e) => onChangeOperation(index, e)}
                      >
                        <CustomRadio control={<Radio size='small' />} value='' label='None' />
                        <CustomRadio control={<Radio size='small' />} value='wgt' label='Wgt' />
                        <CustomRadio control={<Radio size='small' />} value='cost' label='Final Amount' />
                      </RadioGroup>
                    </Grid>
                  )}
                  <Grid item xs className={`${importStyles.deleteIcon}`}>
                    <Stack direction='row' spacing={1}>
                      <Badge color='error' variant='dot' classes={{ badge: ` ${importStyles.badge}` }} overlap='circular'
                        invisible={
                          !value?.effective_date || value?.effective_date === '' || value?.effective_date === 'Invalid date' ||
                          value?.unit != 'cost_manual' && ['number', 'kg', 'kg_per_day']?.includes(value.unit) && !value?.new_cost_per_unit ||
                          value?.unit != 'cost_manual' && value.unit == 'cost' && !value?.new_cost ||
                          value?.unit != 'cost_manual' && value.unit == 'percent' && !value?.new_percent
                        }
                      >
                        <IconButton size='small' color='primary'
                          disableRipple
                          className={importStyles.timeIcon}
                          onClick={() => props.handleOpenDialog('effective_details', {
                            value,
                            index
                          })}
                          disabled={value?.unit == 'cost_manual'}
                        >
                          <AccessTime sx={{ fontSize: 18 }} />
                        </IconButton>
                      </Badge>
                      <DeleteIcon className={`${styles.actionIcons}`} onClick={() => props.removeOperation(index)} />
                    </Stack>
                  </Grid>
                </Grid>
              </StyledCard>
            );
          })}

          <Stack direction='row' justifyContent='space-between' width={'96%'} margin='auto' className={serviceFields.value?.length === 0 && serviceFieldsErrors.value_remark ? importStyles.remarkWrap : ''}>
            {serviceFields.value?.length === 0 && serviceFieldsErrors.value_remark &&
              <Typography fontSize='inherit' color='error'>{serviceFieldsErrors.value_remark}</Typography>}
            <Button variant={serviceFields.value?.length === 0 && serviceFieldsErrors.value_remark ? false : 'outlined'} size='small' fullWidth={serviceFields.value?.length === 0 && serviceFieldsErrors.value_remark ? false : true} className={importStyles.addOperations} onClick={props.addOperation} >
              <AddIcon title='Add Operations' onClick={props.addOperation} className={`${styles.actionIcons} ${importStyles.smallIcon} ${styles.mr2}`} />
              Add Operations
            </Button>
          </Stack>

        </Grid>

        <Grid item xs={12} md={12}>
          <CustomCheckbox
            control={
              <Checkbox
                name='is_spl'
                color='primary'
                checked={Boolean(serviceFields.is_spl)}
                onChange={onChange}
                inputProps={{ 'aria-label': 'is_spl' }}
              />
            }
            label='Link to SPL Codes'
            className={importStyles.operationsCheckbox}
            classes={{ label: importStyles.operationsLabel }}
          />
          {serviceFields.is_spl && <CustomInputLabel className={importStyles.labelWrap} htmlFor='spl_code'>SPL Codes</CustomInputLabel>}
          {/* {serviceFields.is_spl && <CustomSelect
            {...SelectInputProps}
            id=''
            name='spl_code'
            value={serviceFields?.spl_code?.split(',') || []}
            onChange={onChange}
            inputProps={{ 'aria-label': 'Without label' }}
            multiple
            fullWidth
          >
            {props.splCodes?.map((item) => {
              return (<MenuItem key={item} value={item}>
                {item}
              </MenuItem>
              );
            })}
          </CustomSelect>} */}
          {serviceFields.is_spl && <CustomTextField
            {...InputProps}
            fullWidth
            id='spl_code'
            placeholder='SPL Code'
            type='text'
            onChange={onChange}
            name='spl_code'
            value={serviceFields.spl_code}
            error={serviceFieldsErrors.spl_code}
            InputProps={{
              disableUnderline: true,
              classes: {
                root: importStyles.operationsIpRoot,
                input: importStyles.operationsIp
              },
            }}
          />}
        </Grid>

        <Grid item xs={12} md={12}>
          <CustomInputLabel className={importStyles.labelWrap} htmlFor='service'>Override Existing Service</CustomInputLabel>
          <CustomSelect
            {...SelectInputProps}
            fullWidth
            id='service'
            name='master'
            value={serviceFields.master ? serviceFields.master : false}
            onChange={onChange}
            error={serviceFieldsErrors.master}
          >
            <MenuItem value={false}>None</MenuItem>
            {props.services?.map((service) => {
              if (service.key != serviceFields.key && !service.master)
                return <MenuItem key={service.id} value={service.key}>{service.key}</MenuItem>;
            })}
          </CustomSelect>
        </Grid>

        <Grid item xs={12} md={12}>
          <CustomCheckbox
            control={
              <Checkbox
                name='default'
                color='primary'
                checked={Boolean(serviceFields.default)}
                onChange={onChange}
                inputProps={{ 'aria-label': 'default' }}
              />
            }
            label='Default Service'
          />
          {/* <CustomCheckbox
                    control={
                      <Checkbox
                        name='reason'
                        color='primary'
                        checked={serviceFields.reason}
                        onChange={onChange}
                        inputProps={{ 'aria-label': 'other service reason' }}
                      />
                    }
                    label='Other Service Reason (Mandatory)'
                  /> */}
          {/* Additional information to GHA */}
          <CustomCheckbox
            control={
              <Checkbox
                name='add_info'
                color='primary'
                checked={Boolean(serviceFields.add_info)}
                onChange={onChange}
                inputProps={{ 'aria-label': 'additional information' }}
              />
            }
            label='Additional Information to GHA (Optional)'
          />
        </Grid>
        <Grid item xs={12} md={12} display={'flex'} justifyContent={'flex-end'}>
          <CustomButton variant='contained' type='submit'>{action == 'add' ? 'Submit' : 'Update'}</CustomButton>
        </Grid>
      </Grid>
    </form>
  );
};
export default AdditionalService;